module.exports = __webpack_public_path__ + "img/images-search.bc4b0280.png";